import { EmailCycleStatus } from "@pulse/pulse-rpcs/lib/email-cycle/emailCycleStatus";
import { ChipProps } from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";

export const getEmailCycleStatusChipProps = (
  t: TFunction,
  status: EmailCycleStatus.EmailCycleStatus,
): ChipProps => {
  switch (status) {
    case EmailCycleStatus.EmailCycleStatus.QUEUED:
      return {
        label: t("emailCycles.queued"),
        color: "neutral",
      };
    case EmailCycleStatus.EmailCycleStatus.IN_PROGRESS:
      return {
        label: t("surveyLinkStatus.inProgress"),
        color: "orangeSubtle",
      };
    case EmailCycleStatus.EmailCycleStatus.COMPLETED:
      return {
        label: t("emailCycles.completed"),
        color: "greenSubtle",
      };
    case EmailCycleStatus.EmailCycleStatus.STOPPED:
      return {
        label: t("emailCycles.stopped"),
        color: "redSubtle",
      };
    default:
      return status satisfies never;
  }
};
